import React from "react";
import PayrollTable from "./components/PayrollTable";
import { connect } from "react-redux";

const Payrolls = () => {
	
	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
	      	<PayrollTable />
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
  
});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(Payrolls);